import { connect } from 'react-redux';
import { IVerifyPhoneProps, VerifyPhone } from './VerifyPhone';

import {
  verifyPhoneShow,
  verifyPhoneErrorMessage,
  verifyPhoneSecondsToRetrySms,
  verifyPhoneSecondsToRetrySmsChangedAction,
} from '@cian/sms-validation-widget';
import { demandGetRequestedPhone } from '@cian/demand-trap-widget';
import { IState } from '../../store';
import { Dispatch } from 'redux';
import { verifyPhoneRetry } from '../../store/verifyPhone/verifyPhoneRetryThunk';
import { verifyPhoneRequest } from '../../store/verifyPhone/verifyPhoneThunk';
import { verifyPhoneCloseModal } from '../../store/verifyPhone/verifyPhoneCloseModalThunk';

type TMapProps = Pick<IVerifyPhoneProps, 'phone' | 'showVerifyPhone' | 'verificationError' | 'secondsToRetrySms'>;

type TActionProps = Pick<IVerifyPhoneProps, 'retrySendingSms' | 'retrySecondsChange' | 'onApprove' | 'onCloseClick'>;

export const mapStateToProps = (state: IState): TMapProps => ({
  phone: demandGetRequestedPhone(state),
  showVerifyPhone: verifyPhoneShow(state),
  verificationError: verifyPhoneErrorMessage(state),
  secondsToRetrySms: verifyPhoneSecondsToRetrySms(state),
});

export const actions = (dispatch: Dispatch<IState>): TActionProps => ({
  retrySendingSms() {
    dispatch(verifyPhoneRetry());
  },
  retrySecondsChange(seconds: number) {
    dispatch(verifyPhoneSecondsToRetrySmsChangedAction(seconds));
  },
  onApprove(smsCode: string) {
    dispatch(verifyPhoneRequest(smsCode));
  },
  onCloseClick() {
    dispatch(verifyPhoneCloseModal());
  },
});

export const VerifyPhoneContainer = connect(mapStateToProps, actions)(VerifyPhone);
